import {
  DISABLED,
  NOT_STARTED,
  STARTED,
  COMPLETED,
  LEADER_APPROVED,
  COUNSELOR_APPROVED,
  APPROVED,
  AWARDED,
  advancementTypes,
} from "./advancements";
import { STATUS_COLORS } from "./colors";

const { ELECTIVE } = advancementTypes;

export const states = {
  disabled: DISABLED,
  initial: NOT_STARTED,
  check: STARTED,
  submit: COMPLETED,
  approved: LEADER_APPROVED,
  counselorApproved: COUNSELOR_APPROVED,
  awarded: AWARDED,
};

export const byStatus = () => {
  return {
    [states.disabled]: {
      color: STATUS_COLORS.NOT_STARTED,
      icon: "block",
      label: "Blocked",
    },
    [states.initial]: {
      color: STATUS_COLORS.NOT_STARTED,
      icon: "remove-circle",
      label: "Not Started",
    },
    [states.check]: {
      color: STATUS_COLORS.IN_PROGRESS,
      icon: "fiber-manual-record",
      label: "In Progress",
    },
    [states.submit]: {
      color: STATUS_COLORS.COMPLETED,
      icon: "history",
      label: "Waiting for Approval",
    },
    [APPROVED]: {
      color: STATUS_COLORS.LEADER_APPROVED,
      icon: "check-circle",
      label: "Approved",
    },
    [states.approved]: {
      color: STATUS_COLORS.LEADER_APPROVED,
      icon: "check-circle",
      label: "Approved",
    },
    [states.counselorApproved]: {
      color: STATUS_COLORS.COUNSELOR_APPROVED,
      icon: "check",
      label: "MBC Approved",
    },
    [states.awarded]: {
      color: STATUS_COLORS.AWARDED,
      icon: "stars",
      label: "Awarded",
    },
  };
};

export const iconNames = {
  [states.submit]: "history",
  [states.initial]: "brightness-1",
  [states.check]: "brightness-1",
  [states.approved]: "check-circle",
  [states.counselorApproved]: "check",
  [states.awarded]: "star",
};

export const allowPush = {
  [states.initial]: true,
  [states.check]: true,
  [states.submit]: true,
};

export const onClickStatus = {
  [states.initial]: states.check,
  [states.check]: states.initial,
  [states.submit]: states.initial,
};

export const onStatusUpdate = {
  [states.initial]: states.submit,
  [states.check]: states.submit,
  [states.submit]: states.initial,
};

export const disableUpdate = {
  [states.submit]: false,
  [states.initial]: false,
  [states.check]: false,
  [states.approved]: true,
  [states.counselorApproved]: true,
  [states.awarded]: true,
};

const defaultRequirementDisplay = { headerNumberProp: "listNumber" };
const requirementDisplay = { [ELECTIVE]: { headerNumberProp: "ssLevel" } };
requirementDisplay.default = defaultRequirementDisplay;

export { requirementDisplay };

export default {
  states,
  iconNames,
  allowPush,
  onClickStatus,
  onStatusUpdate,
  disableUpdate,
};
